export const IMPORT_FEEDBACK_COHORTS = [
  "new-trial-v1",
  "existing-paid-v1",
  "existing-legacy-v1",
] as const;

export type ImportFeedbackCohort = (typeof IMPORT_FEEDBACK_COHORTS)[number];

export function isImportFeedbackCohort(value: unknown): value is ImportFeedbackCohort {
  return IMPORT_FEEDBACK_COHORTS.some((cohort) => cohort === value);
}
